import React from 'react'
import styles from './lockUnlockHeader.module.css';
import LockIcon from '../../../../../Components/Icons/lockIcon';
import WarningIcon from '../../../../../Components/Icons/warningIcon';
import { Button } from '@mui/material';
import ExportIcon from '../../../../../Components/Icons/exportIcon';
import UnlockIconOutlined from '../../../../../Components/Icons/unlockOutlined';
import UnlockIcon from '../../../../../Components/Icons/unlockIcon';
import UnlockConfirmationDialog from '../../../../../Components/tableComponent/getTableColumn/ChildComponents/EscalationIcons/UnlockConfirmationDialog';
import SsnKeyIcon from '../../../../../Components/Icons/ssnKey';
import { UnlockSsnDialog } from '../../../unlockSsnDialog/unlockSsnDialog';
import { UnlockedSsnHeader } from '../../../unlockedSsnHeader/unlockedSsnHeader';
import { useLockUnlockHeader } from './useLockUnlockHeader';

interface LockUnlockHeaderProps {
    currentAppDetails: Record<string, any>;
}

export const LockUnlockHeader = (props: LockUnlockHeaderProps) => {
    const { currentAppDetails } = props;
    const {
        isApplicationLocked,
        isApplicationUnlocked,
        isSsnLocked,
        isSsnUnlocked,
        isUnlockedThroughSsn,
        isAnyLocked,
        isAnyUnlocked,
        shouldRenderHeader,

        title,
        description,
        subDescription,
        beneficiaryOpportunityUrl,
        originalApplicationUrl,
        unlockedUserFullName,

        isUnlockModalOpen,
        isSsnUnlockModalOpen,
        
        openUnlockModal,
        closeUnlockModal,
        openSsnUnlockModal,
        closeSsnUnlockModal,
        handleConfirmUnlock,
        handleConfirmSsnUnlock,
        handleViewBeneficiary,
        handleViewOriginalApplication,
    } = useLockUnlockHeader({ currentAppDetails });

    if (!shouldRenderHeader) return null;

    if (isUnlockedThroughSsn) {
        return <UnlockedSsnHeader opportunityId={currentAppDetails.benefitedSsnApplicationDetails?.lockedOpportunity || ''} />
    }

    return (
        <div className={`${styles.outerCtn} ${isAnyLocked ? styles.lockOuterCtn : styles.unlockOuterCtn}`}>
            <div className={styles.leftCtn}>
                <div className={`${styles.iconCtn} ${isAnyLocked ? styles.lockIconCtn : styles.unlockIconCtn}`}>
                    {isApplicationLocked && <LockIcon width={20} height={20} />}
                    {isApplicationUnlocked && <UnlockIcon width={20} height={20} />}
                    {isSsnLocked && <SsnKeyIcon width={25} height={25} fillColor={'#FFC107'} />}
                    {isSsnUnlocked && <SsnKeyIcon width={25} height={25} fillColor={'#3BB400'} />}
                </div>
            </div>
            <div className={styles.rightCtn}>
                <div className={styles.descriptionCtn}>
                    <p className={`${styles.title} ${isAnyUnlocked ? styles.unlockedTitle : ''}`}>{title}</p>
                    {description && <p className={styles.desc}>{description}</p>}
                    {subDescription && (
                        <div className={styles.subDescCtn}>
                            {isApplicationLocked && <WarningIcon />}
                            <p className={styles.subDesc}>{subDescription}</p>
                        </div>
                    )}
                </div>
                <div className={styles.btnCtn}>
                    {isApplicationLocked && originalApplicationUrl && (
                        <Button
                            sx={{ textTransform: "unset" }}
                            className={`${styles.viewOriginalApplicationButtonStyle} ${styles.buttonStyle}`}
                            onClick={handleViewOriginalApplication}
                            startIcon={<ExportIcon fillColor="#BA1A1A" width={13} height={13} />}
                        >
                            <p className={styles.buttonText}>View Original Application</p>
                        </Button>
                    )}
                    {isApplicationLocked && (
                        <Button
                            sx={{ textTransform: "unset" }}
                            className={`${styles.unlockButtonStyle} ${styles.buttonStyle}`}
                            onClick={openUnlockModal}
                            startIcon={<UnlockIconOutlined fillColor='#52C41A' width={12} height={16} />}
                        >
                            <p className={styles.buttonText}>Unlock Application</p>
                        </Button>
                    )}
                    {isSsnLocked && (
                        <Button
                            sx={{ textTransform: "unset" }}
                            className={`${styles.unlockButtonStyle} ${styles.buttonStyle}`}
                            onClick={openSsnUnlockModal}
                            startIcon={<UnlockIconOutlined fillColor='#52C41A' width={12} height={16} />}
                        >
                            <p className={styles.buttonText}>Unlock & allow new application</p>
                        </Button>
                    )}
                    {isSsnUnlocked && beneficiaryOpportunityUrl && (
                        <Button
                            sx={{ textTransform: "unset" }}
                            className={`${styles.unlockButtonStyle} ${styles.buttonStyle}`}
                            onClick={handleViewBeneficiary}
                            startIcon={<ExportIcon fillColor="#52C41A" width={13} height={13} />}
                        >
                            <p className={styles.buttonText}>Beneficiary</p>
                        </Button>
                    )}
                </div>
            </div>
            <UnlockConfirmationDialog
                open={isUnlockModalOpen}
                onClose={closeUnlockModal}
                onConfirm={handleConfirmUnlock}
                userName={unlockedUserFullName}
                opportunityId={currentAppDetails.opportunityUid}
            />
            <UnlockSsnDialog
                open={isSsnUnlockModalOpen}
                onClose={closeSsnUnlockModal}
                onUnlock={handleConfirmSsnUnlock}
            />
        </div>
    )
}
